import { useEffect, useState } from "react";
import { toast } from "sonner";
import { adminApi, apiError } from "@/lib/api";
import { Panel } from "./AdminUI";

const STATUSES = ["new", "contacted", "closed"];

export const VendorPanel = () => {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    adminApi.get("/admin/vendor-requests").then((r) => setRows(r.data)).catch(() => {});
  }, []);
  const update = async (id, status) => {
    try {
      await adminApi.patch(`/admin/vendor-requests/${id}`, { status });
      setRows((l) => l.map((x) => (x.id === id ? { ...x, status } : x)));
    } catch (e) {
      toast.error(apiError(e));
    }
  };
  return (
    <Panel title={`Vendor packet requests (${rows.length})`}>
      {rows.length === 0 ? <p className="text-sm text-slate-500" data-testid="vendor-empty">No vendor requests yet.</p> : (
        <div className="overflow-x-auto">
          <table className="w-full text-left text-sm" data-testid="vendor-table">
            <thead className="text-xs uppercase text-slate-400"><tr><th className="py-2 pr-4">Date</th><th className="pr-4">Company</th><th className="pr-4">Contact</th><th className="pr-4">Service</th><th className="pr-4">County / property</th><th className="pr-4">Notes</th><th>Status</th></tr></thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id} className="border-t border-slate-100 align-top" data-testid={`vendor-row-${r.id}`}>
                  <td className="py-3 pr-4 whitespace-nowrap">{r.created_at.slice(0, 10)}</td>
                  <td className="pr-4 font-semibold">{r.company}</td>
                  <td className="pr-4">{r.contact_name}<br /><a href={`mailto:${r.email}`} className="text-gold">{r.email}</a><br />{r.phone}</td>
                  <td className="pr-4">{r.service}</td>
                  <td className="pr-4">{r.county || "-"}<br />{r.property_address}</td>
                  <td className="max-w-xs pr-4 text-slate-500">{r.notes}</td>
                  <td><select value={r.status} onChange={(e) => update(r.id, e.target.value)} className="rounded-lg border border-slate-300 px-2 py-1" data-testid={`vendor-status-${r.id}`}>{STATUSES.map((s) => <option key={s}>{s}</option>)}</select></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Panel>
  );
};
